export default __webpack_public_path__ + "static/media/lectors.420eefe1.svg";